jQuery.hotkeys.options.filterTextInputs = false
jQuery.hotkeys.options.filterContentEditable = false
jQuery.hotkeys.options.filterInputAcceptingElements = false

initWidgets = ->
  for key, widget of INTENT.widgets
    if widget.ATTR_NAME?
      getintent.utils.Autoinit.init widget


global_scope_init = ->
  initWidgets()
  init_select2()
  init_numbers_fields()
  init_codemirror()
  INTENT.utils.Forms.update_state_form()

  event = new CustomEvent("init-global-scope");
  document.dispatchEvent event;

init_once = ->
  init_search_dialog();
  INTENT.utils.Forms.action_buttons_handler()
  $('[data-show-loader-on-click]').on 'click', (e) ->
    $(e.target).blur().showLoader('disabled');

$ ->

  global_scope_init()
  init_once();

  $(document).on 'ajaxComplete', (event, xhr, settings) ->

    # don't call init for some ajax queries
    if settings and settings.url
      loc = document.createElement('a')
      loc.href = settings.url
      if !($.inArray(loc.pathname, [
        '/ajax/get_apps'
        '/ajax/get_automated_domains_lists'
        '/ajax/get_automated_ips_lists'
        '/ajax/get_automated_app_lists'
        '/ajax/get_countries'
        '/ajax/available_advertisers'
        '/ajax/available_campaigns'
        '/ajax/available_contracts'
        '/ajax/available_sites'
        '/ajax/available_creatives'
        '/ajax/get_regions'
        '/ajax/get_cities'
        '/ajax/check_continent'
        '/ajax/check_daily_budget'
        '/ajax/validate_json'
        '/ajax/v2/campaigns/get_dynamic_prices',
        '/api/v3/fields/creatives/tns_articles',
        '/api/v3/fields/creatives/tns_brands',
        '/api/v3/fields/creatives/ktus',
        '/api/v3/user/analytics_auth_url',
        ]) == -1)
        return

    global_scope_init()
    return
